import React from 'react';
import PropTypes from 'prop-types';
import { i18next, utils as utilsSdk } from '@yola/ws-sdk';
import { designSystem } from '@yola/ws-ui';
import utils from 'src/js/modules/utils';

const { Stack, Box, Paragraph, ControlGroup, TagInputField, TextAreaField, CheckboxField } =
  designSystem;
const { createRequiredValidator } = utils.validators;

const emailsValidation = (emails) => {
  if (!emails.length) {
    return i18next.t('Please enter a valid email address');
  }

  if (emails.length > 10) {
    return i18next.t('Please enter no more than 10 email addresses');
  }

  const invalidEmails = [];

  emails.forEach(({ value }) => {
    if (!utilsSdk.validation.isEmail(value)) invalidEmails.push(value);
  });

  if (invalidEmails.length) {
    return `${i18next.t('Invalid email')}: ${invalidEmails.join(', ')}. ${i18next.t(
      'Please enter a valid email address'
    )}`;
  }

  return null;
};

const AdvancedTab = ({ control, isGdprEnabled, onGdprChange }) => (
  <Stack gap="spacing-m">
    <Stack gap="spacing-3-xs">
      <ControlGroup title={i18next.t('Recipients')} required>
        <TagInputField
          name="emails"
          control={control}
          rules={{
            validate: emailsValidation,
          }}
        />
      </ControlGroup>
      <Paragraph size="small" appearance="medium-emphasis">
        {i18next.t('Email address to which form submissions will be sent.')}
      </Paragraph>
    </Stack>
    <Stack gap="spacing-3-xs">
      <ControlGroup title={i18next.t('Success message')} required>
        <TextAreaField
          name="successMessage"
          control={control}
          rules={{
            validate: createRequiredValidator(
              i18next.t('Invalid field. Success message can not be empty.')
            ),
          }}
        />
      </ControlGroup>
      <Paragraph size="small" appearance="medium-emphasis">
        {i18next.t('Display this message to users after they submit your form.')}
      </Paragraph>
    </Stack>
    {isGdprEnabled && (
      <Box>
        <CheckboxField
          name="gdpr"
          control={control}
          label={i18next.t('Display GDPR consent field')}
          onChange={onGdprChange}
        />
        <Box paddingLeft="spacing-l">
          <Paragraph size="small" appearance="medium-emphasis">
            {i18next.t(
              'Require your visitors to agree with the Terms & Conditions and Privacy Policy of your website.'
            )}
          </Paragraph>
        </Box>
      </Box>
    )}
  </Stack>
);

AdvancedTab.propTypes = {
  control: PropTypes.shape({}).isRequired,
  isGdprEnabled: PropTypes.bool.isRequired,
  onGdprChange: PropTypes.func.isRequired,
};

export default AdvancedTab;
